const styles = {
  gutterBottom: {
    marginBottom: 8
  }
};

export default styles